import { Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { HoldToConfirmButton } from "@src/appV2/redesign/components/HoldToConfirmButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

import { DialogFooter } from "../../../components/DialogFooter";

interface EarlyClockOutConfirmationProps {
  modalState: UseModalState;
  formattedDurationBeforeEnd: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function EarlyClockOutConfirmation(props: EarlyClockOutConfirmationProps) {
  const { modalState, formattedDurationBeforeEnd, onConfirm, onCancel } = props;

  const handleClose = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <HoldToConfirmButton fullWidth size="large" isLoading={false} onConfirm={onConfirm}>
            Press and hold to clock out now
          </HoldToConfirmButton>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="hours-limit"
        title="Are you sure you want to clock out?"
        description={
          <Stack spacing={2} sx={{ paddingX: 12, paddingTop: 2 }}>
            <Text variant="body1">
              You are about to clock out <strong>{formattedDurationBeforeEnd}</strong> before the
              scheduled end of your shift. This action is irreversible.
            </Text>
          </Stack>
        }
      />
    </BottomSheet>
  );
}
